/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { FunctionComponent } from 'react'
import { ScrollView } from 'react-native'

import { ModalScreenWrapper } from 'shared/ModalScreenWrapper/ModalScreenWrapper'
import { ModalSimpleContent } from 'ui/designSystem/ModalSimple/ModalSimpleContent'
import { ModalSimpleFooter } from 'ui/designSystem/ModalSimple/ModalSimpleFooter'
import { ModalSimpleHeader } from 'ui/designSystem/ModalSimple/ModalSimpleHeader'
import { ModalSimpleProps } from 'ui/designSystem/ModalSimple/types'

export const ModalSimple: FunctionComponent<ModalSimpleProps> = ({
  title,
  illustration,
  description,
  onClose,
  primaryButton,
  secondaryButton,
  tertiaryButton,
}) => {
  return (
    <ModalScreenWrapper title={title} onClose={onClose}>
      {(closeWithTransition) => (
        <React.Fragment>
          <ModalSimpleHeader onClose={closeWithTransition} />
          <ScrollView bounces={false} showsVerticalScrollIndicator={false} tabIndex={0}>
            <ModalSimpleContent
              title={title}
              description={description}
              illustration={illustration}
            />
          </ScrollView>
          <ModalSimpleFooter
            primaryButton={primaryButton}
            secondaryButton={secondaryButton}
            tertiaryButton={tertiaryButton}
          />
        </React.Fragment>
      )}
    </ModalScreenWrapper>
  )
}
